import { Link } from "react-router-dom";
import { Award, Newspaper } from "lucide-react";
import { Logo } from "./Bits";
import { login } from "../context/auth";

export const SOURCEWISE_URL = "https://mysourcewise.com/how-respite-helped-a-family-caregiver-find-his-creative-spark-again/";

const NAV = [
  ["/story", "Story", "nav-story-link"],
  ["/film", "Film", "nav-film-link"],
];

export function SiteHeader() {
  return (
    <header className="mx-auto flex max-w-5xl items-center justify-between gap-2 px-5 py-5 sm:px-8">
      <Logo />
      <div className="flex items-center gap-1 sm:gap-2">
        {NAV.map(([to, label, tid]) => (
          <Link key={to} to={to} data-testid={`header-${tid}`} className="inline-flex min-h-[44px] items-center px-2 text-[14px] font-semibold text-hf-green hover:underline hover:underline-offset-4 sm:px-3">
            {label}
          </Link>
        ))}
        <Link to="/demo" data-testid="header-demo-link" className="hf-arrow hidden min-h-[44px] items-center px-3 text-[14px] font-semibold text-hf-green sm:inline-flex">
          See the demo
        </Link>
        <button data-testid="header-signin-button" onClick={() => login("/app")} className="h-9 rounded-full bg-hf-green px-4 text-[13.5px] font-semibold text-white transition-[filter] hover:brightness-110">
          Sign in
        </button>
      </div>
    </header>
  );
}

export const SourcewiseBadge = ({ testid = "sourcewise-badge" }) => (
  <a href={SOURCEWISE_URL} target="_blank" rel="noopener noreferrer" data-testid={testid} className="inline-flex items-center gap-2 rounded-full border-[1.5px] border-hf-line bg-white px-4 py-2 text-[14px] font-semibold text-hf-green transition-colors hover:border-hf-green">
    <Newspaper className="h-4 w-4 text-hf-coraldark" /> As featured by Sourcewise
  </a>
);

export function SiteFooter() {
  return (
    <footer className="border-t-[1.5px] border-hf-line">
      <div className="mx-auto flex max-w-5xl flex-col gap-6 px-5 py-10 sm:flex-row sm:items-start sm:justify-between sm:px-8">
        <div>
          <Logo />
          <p className="mt-2 text-base text-hf-muted">Taking a break is caregiving, too. Handoff is a pilot.</p>
          <nav className="mt-4 flex gap-5">
            {NAV.map(([to, label, tid]) => (
              <Link key={to} to={to} data-testid={`footer-${tid}`} className="text-[15px] font-semibold text-hf-green hover:underline hover:underline-offset-4">{label}</Link>
            ))}
            <Link to="/demo" data-testid="footer-demo-link" className="text-[15px] font-semibold text-hf-green hover:underline hover:underline-offset-4">Demo</Link>
          </nav>
        </div>
        <div className="flex flex-col items-start gap-3 sm:items-end">
          <Link to="/story" data-testid="accelerator-link" className="inline-flex items-center gap-2 text-base text-hf-green underline-offset-4 hover:underline">
            <Award className="h-5 w-5 text-hf-coral" /> First place of 206 projects, AI Squads HelpBnk Accelerator, July 2026.
          </Link>
          <SourcewiseBadge testid="footer-sourcewise-badge" />
        </div>
      </div>
    </footer>
  );
}
